import { ReviewPopover } from 'trellis-ecosystem';
import { useEcosystemReviews } from '../../hooks/useEcosystemReviews';
import { jsx as _jsx } from "react/jsx-runtime";
export function EcosystemReviewPopover({
  bodyContent,
  children,
  customValidationErrors,
  defaultReview,
  editReason,
  errorAlertMessage,
  errorAlertTitle,
  headerContent,
  isEditing,
  offeringId,
  onChange,
  onClose,
  onFail,
  onSuccess,
  originalReview,
  overrideSubmitValidation,
  popoverProps,
  reviewFormatter,
  reviewId,
  reviewType,
  submitButtonText,
  successAlertMessage,
  successAlertTitle,
  validationSchema
}) {
  const {
    formattedCustomValidationErrors,
    formattedValidationSchema,
    handleChange,
    handleSubmit
  } = useEcosystemReviews({
    customValidationErrors,
    isEditing,
    editReason,
    errorAlertMessage,
    errorAlertTitle,
    offeringId,
    onChange,
    onFail,
    onSuccess,
    originalReview,
    overrideSubmitValidation,
    reviewFormatter,
    reviewId,
    reviewType,
    successAlertMessage,
    successAlertTitle,
    validationSchema
  });
  return /*#__PURE__*/_jsx(ReviewPopover, {
    bodyContent: bodyContent,
    customValidationErrors: formattedCustomValidationErrors,
    defaultReview: defaultReview,
    headerContent: headerContent,
    onChange: handleChange,
    onClose: onClose,
    onSubmit: handleSubmit,
    popoverProps: popoverProps,
    submitButtonText: submitButtonText,
    validationSchema: formattedValidationSchema,
    children: children
  });
}